import React from 'react';

function Merch() {
  return <div>Come back soon :~)</div>;
}

export default Merch;
